import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../../../../main-page/main-page.service';
import { InsulationMaterialManagmentComponent } from '../insulation-material-managment/insulation-material-managment.component';
import { InsulationMaterialModel } from '../../../../models/dictionaries/insulation-material.model';
declare var $: any;

@Component({
  selector: 'app-insulation-materials-grid',
  template: `<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this Insulation Material?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deleteInsulationMaterial()">Delete</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!isInsulationMaterialChoosen">
    <div class="input-effect">
        <input class="effect1" type="text" placeholder="">
        <label>Search</label>
        <span class="focus-border"></span>
    </div>
    <button class="red-button" type="button" data-toggle="modal" data-target="#addModal" (click)="createNewInsulationMaterial()">Create</button>

    <table>
        <tr>
            <th *ngFor="let header of headers">{{header}}</th>
        </tr>
        <tr *ngFor="let insulationMaterial of insulationMaterialsGridData, let row_no = index">
            <td>{{insulationMaterial.name}}</td>
            <td>{{insulationMaterial.density}}</td>
            <td class="columnWithIcons">
                <button type="button" class="btn editBtn" (click)="editInsulationMaterial(insulationMaterial)">
                    <i class="fa fa-edit"></i>
                </button>
                <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(insulationMaterial)">
                    <i class="fa fa-trash"></i>
                </button>
            </td>
        </tr>
    </table>
</div>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}`]
})
export class InsulationMaterialsGridComponent implements OnInit {
  @Input() managmentComponent: InsulationMaterialManagmentComponent;
  isInsulationMaterialsHidden = true;
  insulationMaterialsGridData: InsulationMaterialModel[];
  selectedInsulationMaterial: InsulationMaterialModel;
  isInsulationMaterialChoosen: boolean = false;
  elementIndex: number;
  headers: string[] = ['Name', 'Density', ''];

  constructor(private mainPageService: MainPageService) { }

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deleteInsulationMaterialSubject.subscribe((value) => {
      this.insulationMaterialsGridData = this.insulationMaterialsGridData.filter(x => x._id !== value);
    });
    this.managmentComponent.stateSubject.subscribe((state) => {
      if (state !== null) {
        Object.assign(this.insulationMaterialsGridData[this.elementIndex], state);
      }
      this.isInsulationMaterialChoosen = false;
    })
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllInsulationMaterials().subscribe((response) => {
      this.insulationMaterialsGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
      $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isInsulationMaterialsHidden = !this.isInsulationMaterialsHidden;
  }

  createNewInsulationMaterial() {
    const insulationMaterial = new InsulationMaterialModel();
    this.mainPageService.addNewInsulationMaterialIntoDb(JSON.stringify(insulationMaterial)).subscribe((response) => {
      insulationMaterial._id = response._id;
      insulationMaterial.id = response.id;
      this.insulationMaterialsGridData.push(insulationMaterial);
      this.elementIndex = this.insulationMaterialsGridData.indexOf(insulationMaterial);
      this.managmentComponent.showManagmentPage(insulationMaterial, true);
    });
    this.isInsulationMaterialChoosen = true;
  }

  setChoosenElement(element) {
    this.selectedInsulationMaterial = {
      ...element,
    };
    this.elementIndex = this.insulationMaterialsGridData.indexOf(element);
  };

  editInsulationMaterial(element) {
    this.selectedInsulationMaterial = {
      ...element,
    };
    this.elementIndex = this.insulationMaterialsGridData.indexOf(element);
    this.managmentComponent.showManagmentPage(this.selectedInsulationMaterial);
    this.isInsulationMaterialChoosen = true;
  }

  deleteInsulationMaterial() {
    this.mainPageService.removeInsulationMaterial(this.selectedInsulationMaterial._id).subscribe((res) => { }, (error: any) => { });
    this.mainPageService.deleteInsulationMaterialSubject.next(this.selectedInsulationMaterial._id);
  }
}
